import React, { useState, useEffect, useContext } from "react";
import { useParams, Navigate } from "react-router-dom";
import { useLeaderboard } from "../hooks/useLeaderboard";
import { DivisionContext } from "../App";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Leaderboard from "../components/Leaderboard";
import Pagination from "../components/Pagination";
import { isValidDivision } from "../constants/divisions";
const PER_PAGE = 100;

export default function LeaderboardPage() {
  const { division } = useParams<{ division: string }>();
  const { setLastDivision } = useContext(DivisionContext);
  const [currentPage, setCurrentPage] = useState(1);

  // Save the current division to context
  useEffect(() => {
    if (division && isValidDivision(division)) {
      setLastDivision(division);
    }
  }, [division, setLastDivision]);

  // Redirect to D1 if division is invalid
  if (!division || !isValidDivision(division)) {
    return <Navigate to="/leaderboard/D1" replace />;
  }

  const { data, loading, error } = useLeaderboard(
    division,
    currentPage,
    PER_PAGE
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="app-container">
      <Header />

      <main className="main-content">
        <div className="page-header">
          <h2>{division} Leaderboard Free Shot Competition</h2>
          <p>
            Results are preliminary. Subject to verification. See{" "}
            <a
              href="https://bit.ly/PWClerkRules"
              target="_blank"
              rel="noopener noreferrer"
            >
              Official Rules
            </a>
          </p>
        </div>

        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading leaderboard data...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p className="error-message">Error: {error}</p>
            <p>Please try refreshing the page or contact support.</p>
          </div>
        )}

        {!loading && !error && data && (
          <>
            <Leaderboard
              stores={data.stores}
              division={data.division}
              isActive={data.is_active}
            />

            {data.total_pages > 1 && (
              <Pagination
                currentPage={data.page}
                totalPages={data.total_pages}
                totalItems={data.total_items}
                perPage={data.per_page}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </main>

      <Footer updatedAt={data?.updated_at} isActive={data?.is_active} />
    </div>
  );
}
